// extracted by mini-css-extract-plugin
module.exports = {"prognosisWarningBox":"HistoryTable_prognosisWarningBox_p9kdg"};